import {MyGlobeKit} from './datapoints.js';
const canvas = document.getElementById('globekit-canvas');

const gk = new MyGlobeKit(canvas);